// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__-9O5q","footer_container":"Footer_footer_container__uwatj","footer_chevron":"Footer_footer_chevron__6RMBG"};